module.exports = __webpack_public_path__ + "static/media/my-offer-active.0a1c6cb3.svg";